export default {
  presuf (num) {
    return '¥' + (num - 0).toFixed(2)
  },
  pre (num) {
    return '¥' + (num - 0)
  },
  suf (num) {
    return (num - 0).toFixed(2)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/priceUtil.js